import React, { useMemo } from 'react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import AgGridTable from 'components/AGGridTable/AgGridTable';
import { Wrapper } from './PreviewData.styles';

const PreviewData = ({ columns, records }) => {
	const gridStyle = useMemo(() => ({ height: '320px' }), []);

	const defaultColDef = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
			resizable: true,
			sortable: true,
			filter: false,
		};
	}, []);

	const columnDefs = useMemo(
		() => {
			const uniques = [];
			const filteredColumns = columns.filter(el => {
				if (!uniques.includes(el.columnName)) {
					uniques.push(el.columnName);
					return true;
				}
				return false;
			});

			return filteredColumns
				.filter(cols => {
					return cols.columnName !== '';
				})
				.map((col, index) => {
					return {
						headerName: col.columnName,
						field: col.columnName,
					};
				});
		},
		[columns]
	);

	const rowData = useMemo(
		() =>
			records.map((_, index) => {
				const row = {};
				columns.forEach(col => {
					row[col.columnName] = col.values[index] ?? '';
				});
				return row;
			}),
		[columns, records]
	);

	const gridOptions = {
		modules: AllModules,
		rowData,
		columnDefs,
		defaultColDef,
	};

	return (
		<Wrapper>
			<AgGridTable gridOptions={gridOptions} gridStyle={gridStyle} />
		</Wrapper>
	);
};

export default PreviewData;
